import { UserData } from "../../types/types";
import Button from "../../components/Button/Button";
import useAuthService from "../../auth/AuthService";
import React, { useEffect, useState } from "react";
import { SideBar } from "../../components/SideBar/SideBar";
import EditPublicInfo from "../../components/Modal/EditPublicInfo/EditPublicInfo";
import { FetchCountrieslookup, FetchLanguageslookup } from "../../services/lookup.service";
import {
  fetchUserProfile,
  UpdateUserProfile
} from "../../services/external.api.service";
import FileUploader from "../../components/Modal/FileUploader/FileUploader";
import { handleMessage } from "../../utils/handleMessagePopup";

interface EditProfileProps {
  handleImageChange: (newImageUrl: string) => void;
  userRole: string;
}

export const EditProfile: React.FC<EditProfileProps> = ({
  handleImageChange,
  userRole,
}) => {
  const { isAuthenticated, getToken } = useAuthService();
  // const { linkInstagram, linkTwitter } = SocialConnections();

  const [state, setState] = useState({
    isPublicInfo: false,
    isPrivateInfo: false,
    isLoading: true,
    isNewAccount: false,
    isFileUploader: false,
    isShowEdit: false,

    isNotification: false,
    isFullName: false,
    first_name: "",
    last_name: "",
    public_bio: "",
    username: "",
    date_of_birth: "",
    country_name: "",
    language: "",
    gender: "",
    twitter_data: {} as any,
    instagram_data: {} as any,
    otherApplicationdetails: "",
    initialPurchasePrice: "",
    role_name: "",
    email: "",
    phone_number: "",
    user_profile_url: "",
    entity_id: "",
    countries: [] as any[],
    languages: [] as any [],
    genders: [
      { id: "Male", value: "Male" },
      { id: "Female", value: "Female" },
      { id: "Others", value: "Others" },
    ] as any[],
    accountLink: true,
    twitter_intervalId: undefined as NodeJS.Timeout | undefined,
    instagram_intervalId: undefined as NodeJS.Timeout | undefined,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const countriesData: any = await FetchCountrieslookup();
        if (Array.isArray(countriesData?.data)) {
          setState((prev) => ({ ...prev, countries: countriesData?.data }));
        }

        const languagesData: any = await FetchLanguageslookup();
        if (Array.isArray(languagesData?.data)) {
          setState((prev) => ({ ...prev, languages: languagesData?.data }));
        }

        if (isAuthenticated) {
          const userProfileData = await fetchUserProfile(getToken);
          if (
            userProfileData.data !== null &&
            userProfileData.error === null &&
            userProfileData.data.user.is_added
          ) {
            const userData: UserData = userProfileData.data.user;
            setState((prev) => ({
              ...prev,
              first_name: userData.first_name,
              last_name: userData.last_name,
              public_bio: userData.public_bio || "",
              username: userData.username || "",
              email: userData.email,
              phone_number: userData.phone_number,
              date_of_birth:
                userData.date_of_birth == null
                  ? ""
                  : userData.date_of_birth.split("T")[0] || "",
              country_name: userData.country_name || "",
              language: userData.language,
              gender: userData.gender || "",
              entity_id: userData.entity_id || "",
              user_profile_url: userData.user_profile_url || "",
              isLoading: false,
              role_name: userData.role_name || "",
              twitter_data: Array.isArray(
                userProfileData.data.social_connections
              )
                ? userProfileData.data.social_connections.find(
                  (connection: any) =>
                    connection.connection_name === "twitter"
                )
                : null,
              instagram_data: Array.isArray(
                userProfileData.data.social_connections
              )
                ? userProfileData.data.social_connections.find(
                  (connection: any) =>
                    connection.connection_name === "instagram"
                )
                : null,
            }));
            handleImageChange(userData.user_profile_url || "");
          } else {
            setState((prev) => ({ ...prev, isNewAccount: true }));
          }
        } else {
          console.error("User not authenticated or user ID not available");
        }
        handleToggle("isLoading", false);
      } catch {
        handleToggle("isLoading", false);
        console.error("User not authenticated or user ID not available");
      }
    };

    fetchData();
    // eslint-disable-next-line
  }, [state.isFileUploader, state.accountLink]);

  const handleToggle = (key: keyof typeof state, value: boolean) => {
    setState((prev) => ({ ...prev, [key]: value }));
  };

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = event.target;
    setState((prev) => ({ ...prev, [name]: checked }));
  };

  // const getId = (options: any, selected: any) => {
  //   const res = options.find((res: any) => res.value === selected);
  //   return res?.id;
  // };

  const handleUpdateInfo = async (
    userData: any,
    modalToggle: keyof typeof state,
    message: string,
    prevState: any
  ) => {
    try {
      handleToggle("isLoading", true);
      const response = await UpdateUserProfile(userData, getToken);
      if (response.data !== null && response.error === null) {
        handleMessage(message);
      } else {
        setState(prevState);
        throw new Error(response.error?.toString());
      }
    } catch (err) {
      setState(prevState);
      console.error(err);
    } finally {
      handleToggle(modalToggle, false);
      handleToggle("isLoading", false);
    }
  };

  // const handleUpdatePrivateInfo = async (userData: any) => {
  //   const prevState = { ...state };
  //   setState((prev) => ({
  //     ...prev,
  //     phone_number: userData.phone_number,
  //     country_id: userData.country_id,
  //     country_name: userData.country_name,
  //     gender: userData.gender,
  //     language: userData.language,
  //     date_of_birth: userData.date_of_birth,
  //   }));
  //   await handleUpdateInfo(
  //     userData,
  //     "isPrivateInfo",
  //     "Private Info Updated",
  //     prevState
  //   );
  // };

  const handleUpdatePublicInfo = async (userData: any) => {
    const prevState = { ...state };
    setState((prev) => ({
      ...prev,
      username: userData.username,
      first_name: userData.first_name,
      last_name: userData.last_name,
      public_bio: userData.public_bio,
    }));
    await handleUpdateInfo(
      userData,
      "isPublicInfo",
      "Public Info Updated",
      prevState
    );
  };

  // const UnlinkSocialAccount = async (provider: "twitter" | "instagram") => {
  //   try {
  //     const socialData =
  //       provider === "twitter" ? state.twitter_data : state.instagram_data;

  //     if (!socialData?.connection_name || !socialData?.connection_id) {
  //       console.error(`Missing data for ${provider} unlinking.`);
  //       return;
  //     }

  //     const data = {
  //       provider: socialData.connection_name,
  //       connection_id: socialData.connection_id,
  //     };

  //     const res = await UnlinkSocialConnection(data, getToken);

  //     if (
  //       res?.data?.message === "Unlink Identitiy successfully" &&
  //       res?.error === null
  //     ) {
  //       // Clear the corresponding social data from the state
  //       setState((prev) => ({
  //         ...prev,
  //         [`${provider}_data`]: {},
  //         accountLink: !prev.accountLink,
  //       }));
  //     } else {
  //       console.error(`Failed to unlink ${provider}.`, res);
  //     }
  //   } catch (err) {
  //     console.error(`Error in unlinking ${provider} account.`, err);
  //   }
  // };

  // const handleSocialConnection = (platform: "twitter" | "instagram") => {
  //   // Trigger connection based on platform
  //   if (platform === "twitter") {
  //     linkTwitter();
  //   } else if (platform === "instagram") {
  //     linkInstagram();
  //   }

  //   // Start checking every 5 seconds
  //   const intervalId = setInterval(() => {
  //     setState((prev) => ({
  //       ...prev,
  //       accountLink: !prev.accountLink,
  //     }));
  //   }, 5000);

  //   setTimeout(() => {
  //     clearInterval(intervalId);
  //   }, 20000);

  //   setState((prev) => ({
  //     ...prev,
  //     [`${platform}_intervalId`]: intervalId,
  //   }));
  // };

  useEffect(() => {
    if (state.twitter_data) {
      clearInterval(state.twitter_intervalId);
    }
    // eslint-disable-next-line
  }, [state.twitter_data]);

  useEffect(() => {
    if (state.instagram_data) {
      clearInterval(state.instagram_intervalId);
    }
    // eslint-disable-next-line
  }, [state.instagram_data]);

  return (
    <>
      <div className="container profile-page ps-2">
        <div className="edit-profile-header py-4">Settings</div>
        <div className="profile-page-data">
          <div className="side-bar">
            <SideBar ActiveItem="profile" userRole={userRole} />
          </div>
          <div className="page-content pb-0 h-100">
            <div className="profile-content">
              <div className="heading mb-3">Profile</div>
              <div className="profile-data">
                <figure className="">
                  {state.isLoading ? (
                    <div className="loader">
                      <div className="spinner"></div>
                    </div>
                  ) : (
                    <>
                      {state.isNewAccount || !state.user_profile_url ? (
                        <div
                          style={{ borderRadius: "4px 4px 0px 0px" }}
                          className="user-profile-img position-relative text-dark-purple bg-extra-light-purple"
                        >
                          <i className="fa-solid fa-user pt-4 d-flex justify-content-center"></i>
                          <Button
                            className="position-absolute user-profile-btn"
                            label={"Add Photo"}
                            onClick={() =>
                              handleToggle(
                                "isFileUploader",
                                !state.isFileUploader
                              )
                            }
                          />
                        </div>
                      ) : (
                        <div
                          className="w-100 position-relative"
                          onMouseOver={() => handleToggle("isShowEdit", true)}
                          onMouseOut={() => handleToggle("isShowEdit", false)}
                        >
                          <img
                            src={state.user_profile_url}
                            alt={state?.username || "N/A"}
                            className="user-profile-img"
                            loading="lazy"
                          />
                          <div
                            className={`position-absolute user-profile-edit-btn 
                            ${state.isShowEdit ? "d-flex" : "d-none"}`}
                            onClick={() =>
                              handleToggle(
                                "isFileUploader",
                                !state.isFileUploader
                              )
                            }
                          >
                            <p className="my-auto font-15">Edit</p>
                            <i className="fa-solid fa-pencil ps-2 my-auto"></i>
                          </div>
                        </div>
                      )}
                      {state.role_name === "moderator" && (
                        <div className="w-100 verify">
                          <div className="font-300-15 extra-light-purple mt-2 mx-auto d-flex justify-content-center align-items-center">
                            <div className="">Fan1 Verified</div>
                            <svg
                              width="15"
                              height="16"
                              viewBox="0 0 15 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              className="ms-1"
                            >
                              <path
                                d="M7.5 0.875C8.55469 0.875 9.49219 1.49023 9.96094 2.39844C10.9277 2.07617 12.041 2.31055 12.8027 3.07227C13.5645 3.83398 13.7988 4.94727 13.4766 5.91406C14.3848 6.38281 15 7.32031 15 8.375C15 9.45898 14.3848 10.3965 13.4766 10.8652C13.7988 11.832 13.5645 12.916 12.8027 13.6777C12.041 14.4395 10.9277 14.6738 9.96094 14.3809C9.49219 15.2891 8.55469 15.875 7.5 15.875C6.41602 15.875 5.47852 15.2891 5.00977 14.3809C4.04297 14.6738 2.95898 14.4395 2.19727 13.6777C1.43555 12.916 1.20117 11.832 1.49414 10.8652C0.585938 10.3965 0 9.45898 0 8.375C0 7.32031 0.585938 6.38281 1.49414 5.91406C1.20117 4.94727 1.43555 3.83398 2.19727 3.07227C2.95898 2.31055 4.04297 2.07617 5.00977 2.39844C5.47852 1.49023 6.41602 0.875 7.5 0.875ZM10.8105 6.99805C11.0742 6.73438 11.0742 6.29492 10.8105 6.03125C10.5176 5.73828 10.0781 5.73828 9.81445 6.03125L6.5625 9.2832L5.18555 7.90625C4.89258 7.61328 4.45312 7.61328 4.18945 7.90625C3.89648 8.16992 3.89648 8.60938 4.18945 8.87305L6.06445 10.748C6.32812 11.041 6.76758 11.041 7.06055 10.748L10.8105 6.99805Z"
                                fill="#8671FC"
                              />
                            </svg>
                          </div>
                          {/* <Button
                            type="button"
                            label={<>View Listing</>}
                            className="py-2 mt-2 button w-100"
                            onClick={() => navigate(`/${state.entity_id}`)}
                          /> */}
                        </div>
                      )}
                    </>
                  )}
                </figure>
                <div className="profile-details">
                  <div className="public-details">
                    <div className="sub-heading d-flex my-2">
                      Public Info
                      <div
                        className="link ms-3"
                        onClick={() =>
                          handleToggle("isPublicInfo", !state.isPublicInfo)
                        }
                      >
                        Edit <i className="fa-solid fa-pencil icon ps-1"></i>
                      </div>
                    </div>
                    <div className="d-flex align-items-baseline mb-2">
                      <div className="heading">Username</div>
                      <div className="content">{ state?.username ? <>@{state.username}</> : "N/A"}</div>
                    </div>
                    <div className="d-flex align-items-baseline mb-2">
                      <div className="heading">Full Name</div>
                      <div className="content">
                        {state.isNewAccount ? (
                          <span className="light-purple-color">Add Name</span>
                        ) : (
                          <>
                            {state?.first_name || "N/A"}{" "}
                            {state?.last_name || ""}
                          </>
                        )}
                      </div>
                    </div>
                    <div className="d-flex align-items-baseline mb-2">
                      <div className="heading">Public Bio</div>
                      <div className="content">
                        {state.isNewAccount ? (
                          <span className="light-purple-color">
                            Tell us about yourself
                          </span>
                        ) : (
                          state?.public_bio || "N/A"
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="private-info ">
                    <div className="private-details">
                      <div className="sub-heading d-flex my-2">
                        Private Info
                        {/* <div
                          className="link ms-3"
                          onClick={() =>
                            handleToggle("isPrivateInfo", !state.isPrivateInfo)
                          }
                        >
                          Edit <i className="fa-solid fa-pencil icon ps-1"></i>
                        </div> */}
                      </div>
                      <div className="col-lg-12">
                        {/* <div className="d-flex align-items-baseline mb-2">
                          <div className="heading">Phone</div>
                          <div className="content">
                            {state.isNewAccount ? (
                              <span className="light-purple-color">
                                add phone
                              </span>
                            ) : (
                              state?.phone_number || "N/A"
                            )}
                          </div>
                        </div> */}
                        <div className="d-flex align-items-baseline mb-2">
                          <div className="heading">Email</div>
                          <div className="content slabFanName">
                            {state.isNewAccount ? (
                              <span className="light-purple-color">
                                add email
                              </span>
                            ) : (
                              <> {state?.email || "N/A "}</>
                            )}
                          </div>
                        </div>
                        {/* <div className="d-flex align-items-baseline mb-2">
                          <div className="heading">Country</div>
                          <div className="content">
                            {state.isNewAccount ? (
                              <span className="light-purple-color">
                                add country
                              </span>
                            ) : (
                              state?.country_name || "N/A"
                            )}
                          </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                          <div className="heading">Language</div>
                          <div className="content">
                            {state.isNewAccount ? (
                              <span className="light-purple-color">
                                add language
                              </span>
                            ) : (
                              state?.language || "N/A"
                            )}
                          </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                          <div className="heading">Gender</div>
                          <div className="content">
                            {state.isNewAccount ? (
                              <span className="light-purple-color">
                                add gender
                              </span>
                            ) : (
                              state?.gender || "N/A"
                            )}
                          </div>
                        </div>
                        <div className="d-flex align-items-baseline mb-2">
                          <div className="heading">Birthday</div>
                          <div className="content">
                            {state.isNewAccount ? (
                              <span className="light-purple-color">
                                add birthtday
                              </span>
                            ) : (
                              handleDate(state?.date_of_birth) || "N/A"
                            )}
                          </div>
                        </div> */}
                      </div>
                    </div>

                    {/* <div className="social-details">
                      <h4 className="sub-heading">Social Media</h4>
                      <p className="font-inter-300-14">
                        Help other fans and notable figures know you by
                        connecting your social accounts
                      </p>
                      <div className="d-flex col-9 justify-content-between py-1">
                        <div className="heading my-auto">Twitter</div>
                        {state.twitter_data !== null &&
                        state.twitter_data !== undefined ? (
                          <Button
                            variant="primary"
                            label="Disconnect"
                            className="font-15"
                            onClick={() => {
                              UnlinkSocialAccount("twitter");
                            }}
                          />
                        ) : (
                          <Button
                            variant="primary"
                            label="Connect"
                            className="font-15"
                            onClick={() => handleSocialConnection("twitter")}
                          />
                        )}
                      </div>
                      <div className="d-flex col-9 justify-content-between py-1">
                        <div className="heading my-auto">Instagram</div>
                        {state.instagram_data !== null &&
                        state.instagram_data !== undefined ? (
                          <Button
                            variant="primary"
                            label="Disconnect"
                            className="font-15"
                            onClick={() => {
                              UnlinkSocialAccount("instagram");
                            }}
                          />
                        ) : (
                          <Button
                            variant="primary"
                            label="Connect"
                            className="font-15"
                            onClick={() => handleSocialConnection("instagram")}
                          />
                        )}
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for public info */}
      <EditPublicInfo
        state={state}
        isVisible={state.isPublicInfo}
        handleUpdateInfo={handleUpdatePublicInfo}
        handleCheckboxChange={handleCheckboxChange}
        onClose={() => handleToggle("isPublicInfo", !state.isPublicInfo)}
      />

      {/* Modal for private info */}
      {/* <EditPrivateInfo
        state={state}
        isVisible={state.isPrivateInfo}
        getId={getId}
        handleUpdateInfo={handleUpdatePrivateInfo}
        onClose={() => handleToggle("isPrivateInfo", !state.isPrivateInfo)}
      /> */}

      {/* Modal for File Uploader */}
      <FileUploader
        isVisible={state.isFileUploader}
        handleImageChange={handleImageChange}
        onClick={() => {
          handleToggle("isFileUploader", !state.isFileUploader);
          handleMessage("Public Info Updated");
        }}
        onClose={() => handleToggle("isFileUploader", !state.isFileUploader)}
      />

      {/* <NewAccount isVisible={state.isNewAccount} onClose={() => { handleToggle('isNewAccount', false) }} /> */}
    </>
  );
};
